<template>
  <div class="account-settings-content tab-pane fade show active" id="user-profile" role="tabpanel" aria-labelledby="user-profile-tab">
    <h2>{{$t('account_settings.company_user_profile.user_profile')}}</h2>
    <div class="user-form">
      <form @submit.prevent="submitForm($event)" class="user-data">
        <div class="form-group">
          <label>{{$t('account_settings.company_user_profile.company_name')}}</label>
          <input type="text" name="user[organization_name]" class="form-control" :value="organization.name">
        </div>
        <div class="form-group">
          <label>
            {{$t('account_settings.company_user_profile.your_name')}}
          </label>
          <input type="text" name="user[full_name]" class="form-control" :value="currentUser.full_name">
        </div>
        <div class="form-group">
          <label>{{$t('account_settings.company_user_profile.your_email')}}</label>
          <input type="email" name="user[email]" class="form-control" :value="currentUser.email">
        </div>
        <div class="form-group">
          <label>{{$t('account_settings.company_user_profile.your_phone_number')}}</label>
          <input type="text" name="user[phone]" class="form-control" :value="currentUser.phone">
        </div>
        <div class="form-group">
          <label>{{$t('add_contact_modal.language')}}</label>
          <select name="user[locale]" id="user_locale" class="form-control" :value='currentUser.locale'>
            <option value="de">{{$t('contacts.edit_modal.german')}}</option>
            <option value="en">{{$t('contacts.edit_modal.english')}}</option>
          </select>
        </div>
        <div class="form-group">
          <label>{{$t('account_settings.company_user_profile.your_timezone')}}</label>
          <select name="user[time_zone]" class="form-control" :value='currentUser.time_zone'>
            <option></option>
            <option v-for="item in timeZones" :value="item[0]">
              {{item[1]}}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label>{{$t('account_settings.company_user_profile.global_reminder_days')}}</label>
          <select name="user[organization_contact_reminder_days]" class="form-control expiration-select" :value="org_contact_reminder_days">
            <option value="" selected> {{ $t('expiration.do_not_set') }}</option>
            <option value="-1"> {{ $t('expiration.no_reminder') }}</option>
            <option value="0"> {{ $t('expiration.yes_on_expiration_date') }}</option>
            <option value="5"> {{ $t('expiration.yes_5_days') }}</option>
            <option value="10"> {{ $t('expiration.yes_10_days') }}</option>
            <option value="15"> {{ $t('expiration.yes_2_weeks') }}</option>
            <option value="30"> {{ $t('expiration.yes_1_month') }}</option>
          </select>
        </div>
        <div class="form-group">
          <input type="submit" name="commit" :value="$t('account_settings.company_user_profile.update_profile')" class="btn btn-primary">
        </div>
      </form>
      <form @submit.prevent="submitPasswordForm($event)" class="pass-form">
        <h2>{{$t('account_settings.company_user_profile.change_password')}}</h2>

        <div class="form-group">
          <label>{{$t('account_settings.company_user_profile.current_password')}}</label>
          <input type="password" name="password" class="form-control">
        </div>

        <div class="form-group">
          <label>{{$t('account_settings.company_user_profile.new_password')}}</label>
          <input type="password" name="user[password]" class="form-control">
        </div>

        <div class="form-group">
          <input type="submit" name="commit" :value="$t('account_settings.company_user_profile.update_password')" class="btn btn-primary">
        </div>
      </form>
    </div>
    <div class="user-ident">
      <form>
        <label>{{$t('account_settings.company_user_profile.profile_picture')}}</label>
        <img width="160" height="160" :src="profilePicture" />
        <div class="form-group hide">
          <input ref='userPicture' accept="image/png, image/jpg" type="file" name="user[picture]" @change="changePicture($event, 'picture_url')">
        </div>
        <a @click.prevent='$refs.userPicture.click()' href="#" class="btn btn-outline-primary">
          {{$t('account_settings.company_user_profile.change_picture')}}
        </a>
      </form>
    </div>
    <div class="company-ident">
      <form>
        <label>{{$t('account_settings.company_user_profile.company_logo')}}</label>
        <img width="160" height="160" :src="orgLogo" />
        <div class="form-group hide">
          <input ref='orgLogo' accept="image/png, image/jpg" type="file" name="user[organization_logo]" @change="changePicture($event,'organization_logo_url')">
        </div>
        <a @click.prevent='$refs.orgLogo.click()' href="#" class="btn btn-outline-primary" v-bind:class="{disabled: orgLogoDisabled}">
          {{$t('account_settings.company_user_profile.change_logo')}}
        </a>
        <div class="upload-logo-text"> {{$t('account_settings.company_user_profile.logo_appear_on')}}
          <ul>
            <li>{{$t('account_settings.company_user_profile.emails')}}</li>
            <li>{{$t('account_settings.company_user_profile.upload_pages')}}</li>
          </ul>
        </div>
        <label class="checkbox-container">
          <input type="checkbox" name="user[organization_show_logo]" :checked="organization.show_logo">
          <span class="checkmark" data-toggle="tooltip" title="" data-original-title="Show company logo" @click='showLogo'></span>
          <p> {{$t('account_settings.company_user_profile.logo_checkmark')}}</p>
        </label>
      </form>
    </div>
  </div>
</template>

<script>
  import Uppy from '@uppy/core'
  import XHRUpload from '@uppy/xhr-upload'

  export default {
    data() {
      return {
        uppy: null
      }
    },
    created(){
      this.uppy = Uppy()
      this.store.getTimeZones()
    },
    mounted(){
      this._setupS3()
    },
    computed: {
      profilePicture() {
        if (!this.currentUser.picture_url)
          return require('../../assets/blank-profile-picture.png')

        return this.previewUrl(this.currentUser.picture_url)
      },
      timeZones() {
        return this.state.time_zones || []
      },
      organization() {
        return this.state.organization || {}
      },
      org_contact_reminder_days() {
        return String(this.organization.contact_reminder_days) || {}
      },
      orgLogo(){
        if (!this.organization.logo_url)
          return require('../../assets/blank-logo.png')

        return this.previewUrl(this.organization.logo_url)
      },
      orgLogoDisabled(){
        return !this.currentOrg.active
      }
    },
    methods: {
      _setupS3() {
        this.uppy.use(XHRUpload, {
          endpoint: `${this.baseApiUrl}/inline/upload`,
          method: 'post',
          formData: true,
          fieldName: 'file',
          limit: 1,
          withCredentials: true,
          headers: {
            'Client-ID': process.env.VUE_APP_FRONTEND_CLIENT_ID
          },
          getResponseData(responseText, response) {
            return JSON.parse(responseText)
          }
        }).setMeta({ prefix: 'images/' })

      },
      submitForm(event) {
        this.store.updateUserProfile(new FormData(event.target)).then(() => {
          this.store.getCurrentOrg()
          this.store.getCurrentUser().then(() => {
            this.$toastr.success(this.$t('account_settings.profile_updated'))
          })
        })
      },
      submitPasswordForm(event) {
        this.store.updatePasswordProfile(new FormData(event.target)).then(() => {
          this.$toastr.success(this.$t('account_settings.password_updated'))
          event.target.reset()
        })
      },
      changePicture(event, param) {
        const file = event.target.files[0]

        if (!file || file.size === 0)
          return

        this.uppy.addFile({
          source: 'file input',
          name: file.name,
          type: file.type,
          data: file
        })

        this.uppy.upload().then(({successful}) => {
          successful.forEach(({uploadURL}) => {
            this.store.updateUserProfile({ user: { [param]: uploadURL } }).then(() => {
              param == 'picture_url' ? this.store.getCurrentUser() : this.store.getCurrentOrg()
              param == 'picture_url' ? this.$toastr.success(this.$t('account_settings.company_user_profile.picture_uploaded')) : this.$toastr.success(this.$t('account_settings.company_user_profile.logo_uploaded'))
            })
          })
        })
      },
      showLogo() {
        let show = !this.organization.show_logo
        this.store.updateUserProfile({ user: { organization_show_logo: show } }).then(() => {
          this.store.getCurrentOrg()
        })
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "../../styles/user_profile"
</style>
